export enum AccountType {
  SystemAdmin = 1,
  ClientAdmin,
  ClientUser
}
